// extracted by mini-css-extract-plugin
export var compact = "_n3-2";
export var phoneFrame = "_n3-0";
export var phoneScreen = "_n3-1";